module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.premium_message) ? _c('div', {
    staticClass: "page-header",
    staticStyle: {
      "padding": "1em",
      "border": "#22baae 3px solid"
    }
  }, [_c('p', [_vm._v("Your Free Trial is Over. To Access CNpros, Please Upgrade; See Plans Below.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-header",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('h1', [_vm._v("CNpro Plans & Pricing")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (!_vm.plan_type) ? _c('div', {
    staticClass: "plan-header"
  }, [_vm._m(2)]) : _c('div', [(_vm.user.user_free_plan_option == 1) ? _c('div', {
    staticClass: "plan-header"
  }, [_c('p', [_vm._v("Your "), _c('b', [_vm._v("1 Month Free Plan")]), _vm._v(" ends on " + _vm._s(_vm.user.user_premuim_plan_expiry_date))])]) : (_vm.user.user_premuim_plan_id == 1) ? _c('div', {
    staticClass: "plan-header"
  }, [_c('p', [_vm._v("Your "), _c('b', [_vm._v("Plan expired on " + _vm._s(_vm.user.user_premuim_plan_expiry_date))]), _vm._v(" please subscribe to another plan ")])]) : _c('div', {
    staticClass: "plan-header"
  }, [_c('p', [_vm._v("You are on a "), _c('b', [_vm._v(_vm._s(_vm.user.user_premuim_plan) + " Plan")]), _vm._v(" ending on " + _vm._s(_vm.user.user_premuim_plan_expiry_date))])])])]), _vm._v(" "), _c('div', {
    staticClass: "pricings hidden-sm hidden-xs"
  }, [_c('table', {
    staticClass: "comparison-table"
  }, [_c('thead', [_c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("Quarterly"), _c('br'), _vm._v("(3 months)"), _c('br'), _vm._v("₦"), _c('span', [_vm._v(_vm._s(_vm.plans[0].plan_amount))])]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("Half Year"), _c('br'), _vm._v("(6 months)"), _c('br'), _vm._v("₦"), _c('span', [_vm._v(_vm._s(_vm.plans[1].plan_amount))])]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("Full Year"), _c('br'), _vm._v("(12 months)"), _c('br'), _vm._v("₦"), _c('span', [_vm._v(_vm._s(_vm.plans[2].plan_amount))])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('td'), _vm._v(" "), _vm._l((_vm.plans), function(plan) {
    return _c('td', {
      staticClass: "plans"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      style: ({
        display: _vm.check_free_plan(plan)
      }),
      attrs: {
        "disabled": _vm.disable_btn
      },
      on: {
        "click": function($event) {
          _vm.presetPaymentPlan(plan)
        }
      }
    }, [_vm._v("Select Plan")])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "pricings hidden-lg hidden-md"
  }, [_c('div', {
    staticClass: "col-md-12 pricing-tab",
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "font-size": "12px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-head"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("Quarterly"), _c('br'), _vm._v("(3 months)"), _c('br'), _vm._v("₦"), _c('span', [_vm._v(_vm._s(_vm.plans[0].plan_amount))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("Half Year"), _c('br'), _vm._v("(6 months)"), _c('br'), _vm._v("₦"), _c('span', [_vm._v(_vm._s(_vm.plans[1].plan_amount))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("Full Year"), _c('br'), _vm._v("(12 months)"), _c('br'), _vm._v("₦"), _c('span', [_vm._v(_vm._s(_vm.plans[2].plan_amount))])])])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-head"
  }, _vm._l((_vm.plans), function(plan) {
    return _c('div', {
      staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab",
      staticStyle: {
        "padding": "0px"
      }
    }, [_c('button', {
      staticClass: "btn btn-primary",
      staticStyle: {
        "font-size": "12px"
      },
      style: ({
        display: _vm.check_free_plan(plan)
      }),
      attrs: {
        "disabled": _vm.disable_btn
      },
      on: {
        "click": function($event) {
          _vm.presetPaymentPlan(plan)
        }
      }
    }, [_vm._v("Select Plan")])])
  }))])])])])])]), _vm._v(" "), _c('main-footer'), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "paywith",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', [_c('b', [_vm._v("Amount to pay: ₦" + _vm._s(_vm.selected_plan.plan_amount))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h5', [_vm._v("Process Payment with your CNpay Rewards")]), _vm._v(" "), (_vm.loggedIn) ? _c('div', [_c('p', [_vm._v("Available Balance: ₦" + _vm._s(_vm.formatCurrency(_vm.current_wallet_balance)))]), _vm._v(" "), (_vm.current_wallet_balance > _vm.selected_plan.plan_amount) ? _c('div', [(_vm.disable_btn) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("...processing, please wait")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPaymentPlan('wallet')
      }
    }
  }, [_vm._v("Pay with CNpay Rewards")])]) : _vm._e()]) : _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Please "), _c('a', {
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Login")]), _vm._v(" to use your CNpay Rewards")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h4', [_vm._v("Or")]), _vm._v(" "), _c('h5', [_vm._v("Process Payment from your Bank Account")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPaymentPlan('gateway')
      }
    }
  }, [_vm._v("Pay with Debit Card/Bank")])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("WHY YOU HAVE TO SUBSCRIBE BEFORE YOU CAN CONTACT CNpros:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Finding diligent workers is HARD. Ensuring that workers keep transactions within the loop is EVEN HARDER. "), _c('br'), _vm._v("\r\n                             Subscription fees guarantees that insurance is in place, and keeps conflict mediation mechanism active.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("You are entitled to a 1 Month Free Introductory Plan"), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "register"
    }
  }, [_vm._v("Get Started")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Number of CNpros to Choose From")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("unlimited")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("unlimited")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("unlimited")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Insurance Cover on Accidental Damage of Property by CNpro")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Withholding (Escrow) of CNpro’s Service Fees/Labour Wage until Satisfactory Completion of Job ")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Access to User Support and Conflict Mediation")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Transfer of Unfinished Job to Another CNpro")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Newsletter")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✘")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Do-It-Yourself Tips")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✘")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✘")]), _vm._v(" "), _c('td', {
    staticClass: "plans"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-single"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Number of CNpros to Choose From")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-xx"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("unlimited")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("unlimited")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("unlimited")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-single"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Insurance Cover on Accidental Damage of Property by CNpro")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-x"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-single"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Withholding (Escrow) of CNpro’s Service Fees/Labour Wage until Satisfactory Completion of Job ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-xx"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-single"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Access to User Support and Conflict Mediation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-x"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-single"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Transfer of Unfinished Job to Another CNpro")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-xx"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-single"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Newsletter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-x"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✘")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-single"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Do-It-Yourself Tips")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 row-tab-xx"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✘")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✘")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-4 col-xs-4 col-row-tab-tick",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('p', [_vm._v("✔")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a145f09c"}!./src/components/Pricing/template.html
// module id = 312
// module chunks = 0